import { z } from "zod";

export const EVENTS = {
  initialize: "initialize",
  setHeight: "setHeight",
  openFullView: "openFullView",
  refreshAuthorization: "refreshAuthorization",
} as const;

const BaseEvent = z.object({
  requestId: z.string(),
});

export const RequestEventSchema = z.discriminatedUnion("id", [
  BaseEvent.extend({
    id: z.literal(EVENTS.initialize),
    tileEventsVersion: z.string(),
  }),
  BaseEvent.extend({
    id: z.literal(EVENTS.setHeight),
    height: z.number(),
  }),
  BaseEvent.extend({
    id: z.literal(EVENTS.openFullView),
  }),
  BaseEvent.extend({
    id: z.literal(EVENTS.refreshAuthorization),
  }),
]);

export const ResponseEventSchema = z.discriminatedUnion("id", [
  BaseEvent.extend({
    id: z.literal(EVENTS.initialize),
    isCompatible: z.boolean(),
  }),
  BaseEvent.extend({
    id: z.literal(EVENTS.setHeight),
  }),
  BaseEvent.extend({
    id: z.literal(EVENTS.openFullView),
    opened: z.boolean(),
  }),
  BaseEvent.extend({
    id: z.literal(EVENTS.refreshAuthorization),
    code: z.string().or(z.null()),
  }),
]);

export type Requests = z.infer<typeof RequestEventSchema>;
export type Responses = z.infer<typeof ResponseEventSchema>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type DistributiveOmit<T, K extends keyof any> = T extends any
  ? Omit<T, K>
  : never;
